import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WalletFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M18.24 18.0398H6.52002C6.03998 18.0398 5.76 17.6798 5.76 17.2198V9.2398H18.24V18.0398ZM14.6999 11.9998H16.38V15.6998H14.6999V11.9998Z"
      />
      <path
        fillRule="evenodd"
        d="M5.76 6.77978C5.76 7.2398 6.09998 7.59979 6.58002 7.59979H19.88V19.6798H6.52002C5.12 19.6798 4.12 18.6398 4.12 17.2198V6.77978C4.12 5.3598 5.12 4.31982 6.52002 4.31982H16.92V5.95977H6.58002C6.12 5.95977 5.76 6.31982 5.76 6.77978ZM6.52002 18.0398H18.24V9.2398H5.76V17.2198C5.76 17.6798 6.03998 18.0398 6.52002 18.0398Z"
      />
    </SvgIcon>
  );
});
